import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { patentTypeOptions } from '@/module/Nomen/PatentType/model/PatentTypeModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type PatentTypeSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function PatentTypeSelectControl<T extends FieldValues>(props: PatentTypeSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(patentTypeOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
